import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import CustomProductModalCode from '@/presentation/components/custom-products/custom-product-modal/custom-product-modal.code';

export default defineComponent({
	components: {
		MultiSelect
	},
	setup: (props, context) => {
		const code = new CustomProductModalCode(
			context.emit
		);

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			typeDropdown: code.typeDropdown,
			modalStateIsAddProduct: code.modalStateIsAddProduct,
			modalStateIsDuplicateProduct: code.modalStateIsDuplicateProduct,
			modalStateIsEditProduct: code.modalStateIsEditProduct,
			modalStateIsDeleteProduct: code.modalStateIsDeleteProduct,
			modalTitle: code.modalTitle,
			productName: code.productName,
			productPrice: code.productPrice,
			productDate: code.productDate,
			productDateAsDateString: code.productDateAsDateString,
			productDescription: code.productDescription,
			isDeliveryDateFieldValidatedAndInvalid: code.isDeliveryDateFieldValidatedAndInvalid,
			customProductOptions: code.customProductOptions,
			closeModal: code.closeModal.bind(code),
			updateProductType: code.updateProductType.bind(code),
			onSubmit: code.onSubmit.bind(code),
			addCustomProduct: code.addCustomProduct.bind(code),
			setDate: code.setDate.bind(code),
			setDescription: code.setDescription.bind(code)
		};
	}
});
